import React from "react";
import { Link } from "react-router-dom";
import { MapMulti } from "@/components/Map";

const COUNTRIES = [
  { name: "South Africa", flag: "🇿🇦", lat: -25.7461, lng: 28.1881, city: "Pretoria",   desc: "Home ownership schemes across Gauteng, Western Cape and KwaZulu-Natal.", img: "https://images.unsplash.com/photo-1576485375217-d6a95e34d043" },
  { name: "Zimbabwe",     flag: "🇿🇼", lat: -17.8252, lng: 31.0335, city: "Harare",     desc: "Family homes and land developments in Harare, Bulawayo and Victoria Falls.", img: "https://images.pexels.com/photos/33050276/pexels-photo-33050276.jpeg" },
  { name: "Zambia",       flag: "🇿🇲", lat: -15.3875, lng: 28.3228, city: "Lusaka",     desc: "Modern estates in Lusaka and Kitwe with secure title.", img: "https://images.pexels.com/photos/19344325/pexels-photo-19344325.jpeg" },
  { name: "Botswana",     flag: "🇧🇼", lat: -24.6282, lng: 25.9231, city: "Gaborone",   desc: "Reliable ownership programs across Gaborone and Francistown.", img: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267" },
  { name: "Namibia",      flag: "🇳🇦", lat: -22.5609, lng: 17.0658, city: "Windhoek",   desc: "Coastal and inland properties in Windhoek and Swakopmund.", img: "https://images.unsplash.com/photo-1647616927583-1d44a79a38a5" },
];

export default function CountriesPage() {
  const points = COUNTRIES.map((c) => ({
    lat: c.lat, lng: c.lng,
    title: c.name,
    subtitle: `${c.city} · Home ownership + Investor programs`,
    href: "/projects",
  }));

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
      <div className="mv-eyebrow"><span style={{color:"var(--mv-gold)"}}>Countries We Serve</span></div>
      <h1 className="font-display text-3xl md:text-4xl lg:text-5xl mv-green-text mt-3 leading-tight">
        Southern Africa — <span className="font-accent italic" style={{color:"var(--mv-gold)"}}>five nations, one open door.</span>
      </h1>
      <p className="mt-4 text-[15px] max-w-2xl" style={{color:"var(--mv-muted)"}}>
        We only verify citizenship in the country where you want to invest — never abroad.
      </p>

      {/* Interactive regional map */}
      <div className="mt-12" data-testid="countries-map">
        <MapMulti height={480} items={points} defaultCenter={[-20.5, 25]} defaultZoom={4} />
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {COUNTRIES.map((c) => (
          <div key={c.name} className="mv-card overflow-hidden group" data-testid={`country-${c.name.toLowerCase().replace(/\s+/g,"-")}`}>
            <div className="h-48 overflow-hidden">
              <img src={c.img} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy"/>
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2">
                <span className="text-2xl">{c.flag}</span>
                <h3 className="font-display text-xl mv-green-text">{c.name}</h3>
              </div>
              <p className="mt-2 text-[14px]" style={{color:"var(--mv-muted)"}}>{c.desc}</p>
              <div className="mt-3 text-[11.5px] px-2.5 py-1 rounded-full inline-flex items-center gap-1"
                   style={{ background: "rgba(37,211,102,0.12)", color: "#0A7A2C" }}>
                ✓ Terms apply fully — aligned with {c.name} property law
              </div>
              <Link to="/register-interest" className="mt-4 inline-flex text-[13.5px] font-semibold mv-green-text hover:underline">
                Start here →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
